// src/pages/savings.jsx
import dynamic from 'next/dynamic';
import EnergieberegnerLayout from '../components/EnergieberegnerLayout';
import RequireProject from '../components/RequireProject';

const SavingsCalculator = dynamic(
    () => import('../components/calculators/savings/SavingsCalculator'),
    { ssr: false }
);

export default function SavingsPage() {
    return (
        <EnergieberegnerLayout title="Årlig besparelse">
            <RequireProject>
                <SavingsCalculator />
            </RequireProject>
        </EnergieberegnerLayout>
    );
}
